// removed by extract-text-webpack-plugin
module.exports = {"list":"list___2hDom","item":"item___2sH5s","wrapper":"wrapper___GQUuB","read":"read___pmvzr","content":"content___2SjQK","avatar":"avatar___pIwL0","title":"title___1kgPc","description":"description___1j-CC","datetime":"datetime___3Lc_N","extra":"extra___EiGs2","notFound":"notFound___qqrrt","clear":"clear___sjDKE"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NoticeIcon/NoticeList.less
// module id = 230
// module chunks = 0